import { CoinManagementForm } from './CoinManagementForm'
import { withCoinManagementForm } from './withCoinManagementForm'

const ConnectedCoinManagementForm = withCoinManagementForm(CoinManagementForm)

export { ConnectedCoinManagementForm as CoinManagementForm }
